import { Breadcrumb as PrimitiveBreadcrumb } from '@repo/ui';
import { useNavigate } from 'react-router-dom';
import breadcrumbResultsPortalParser from 'utils/breadcrumb/parser/breadcrumbResultsPortalParser';
import { ScrollHandler } from '@repo/utils';

const scrollHandler = ScrollHandler.instance;

type Props = {
  overrides?: Record<string, string | undefined>;
  className?: string;
};

export default function Breadcrumb({ overrides, className }: Props) {
  const navigate = useNavigate();

  return (
    <PrimitiveBreadcrumb
      parser={breadcrumbResultsPortalParser}
      onNavigate={href => {
        scrollHandler.setScrollRestoration();
        navigate(href);
      }}
      overrides={overrides}
      className={className}
    />
  );
}
